export default __webpack_public_path__ + "static/media/bridge building.57fa385a.webp";